import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { ChevronDown, ChevronUp, CheckCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Y si no tengo tiempo?',
  a: '15 minutos al día. Menos que un episodio de telenovela. Tu salud vale 15 minutos.'
}, {
  q: '¿Y si no funciona para mí?',
  a: 'Garantía 30 días. Si no funciona, dinero de vuelta. Sin riesgo.'
}, {
  q: '¿Y si soy hombre y esto es para mujeres?',
  a: '40% de nuestros usuarios son hombres. Colesterol, glicemia, espalda, tensión: sin género.'
}, {
  q: '¿Y si ya tomo medicamentos?',
  a: 'FAQ completo en el libro. Consulta médico antes de combinar específicos. La mayoría son compatibles.'
}, {
  q: '¿Y si no consigo los ingredientes fácilmente?',
  a: 'Lista de herbolarias online incluida. Envíos a cualquier lugar.'
}, {
  q: '¿$6.97 es mucho?',
  a: 'Una consulta médico privado: $40-$75. Este botiquín: $6.97 para siempre.'
}];
export function ObjectionFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-[#FDF8F0]" data-id="element-245">
      {/* Layer 14: Objections */}
      <h2 className="text-2xl font-bold text-center text-[#2C1810] mb-5" data-id="element-246">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-3 max-w-2xl mx-auto" data-id="element-247">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-lg shadow-sm border border-[#2C1810]/10 overflow-hidden" data-id="element-248">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex justify-between items-center p-4 text-left font-bold text-[#2C1810] hover:bg-gray-50 transition-colors" data-id="element-249">
              <div className="flex items-center gap-3" data-id="element-250">
                {openIndex === idx && <CheckCircle className="w-5 h-5 text-[#2D5016]" data-id="element-251" />}
                <span data-id="element-252">{faq.q}</span>
              </div>
              {openIndex === idx ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-253" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-254" />}
            </button>
            <AnimatePresence data-id="element-255">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-256">
                  <div className="p-4 pt-0 text-[#2C1810]/80 bg-gray-50 border-t border-gray-100 leading-relaxed" data-id="element-257">
                    <p data-id="element-258">→ {faq.a}</p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}